{
  "name": "@threadbase-sh/scanner",
  "version": "0.23.0",
  "description": "Unified Claude Code conversation history scanner",
  "license": "MIT",
  "author": {
    "name": "Ronen Mars",
    "email": "ronenmars@gmail.com"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/RonenMars/threadbase-scanner.git"
  },
  "bugs": {
    "url": "https://github.com/RonenMars/threadbase-scanner/issues"
  },
  "homepage": "https://github.com/RonenMars/threadbase-scanner#readme",
  "keywords": [
    "claude-code",
    "jsonl",
    "scanner",
    "conversation-history",
    "flexsearch",
    "cli"
  ],
  "type": "module",
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "threadbase-scanner": "dist/cli.js"
  },
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./package.json": "./package.json"
  },
  "publishConfig": {
    "access": "public"
  },
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=22"
  },
  "scripts": {
    "build": "tsup && tsc -p tsconfig.build.json",
    "prepare": "npm run build",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:scripts": "vitest run __tests__/scripts",
    "lint": "tsc --noEmit && npx biome check .",
    "format": "npx biome format --write .",
    "check": "npx biome check --write .",
    "capture-live": "bash scripts/capture-live.sh",
    "update-baseline": "bash scripts/update-baseline.sh"
  },
  "dependencies": {
    "better-sqlite3": "^13.0.3",
    "chokidar": "^5.0.0",
    "commander": "^15.0.0",
    "fast-glob": "^3.3.0",
    "flexsearch": "^0.8.212",
    "pino": "^10.3.1",
    "pino-pretty": "^13.1.3"
  },
  "devDependencies": {
    "@biomejs/biome": "^2.4.12",
    "@semantic-release/changelog": "^7.0.0",
    "@semantic-release/commit-analyzer": "^13.0.1",
    "@semantic-release/git": "^11.0.1",
    "@semantic-release/github": "^12.0.8",
    "@semantic-release/npm": "^13.1.5",
    "@semantic-release/release-notes-generator": "^14.1.1",
    "@types/better-sqlite3": "^9.6.0",
    "@types/node": "^26.1.0",
    "conventional-changelog-conventionalcommits": "^10.2.1",
    "semantic-release": "^25.0.5",
    "tsup": "^8.0.0",
    "typescript": "^7.0.2",
    "vitest": "^5.0.0"
  }
}
